








import Vue from 'vue'
import type { Calculate } from '@/models/billing'
import gift from '@/assets/svg/rounded/gift.svg?inline'

interface Props {
  calculated: Calculate
}

interface Computed {
  localPrice: string
}

export default Vue.extend<{}, {}, Computed, Props>({
  components: {
    gift,
  },
  props: {
    calculated: {
      required: true,
    },
  },
  computed: {
    localPrice() {
      if (!this.calculated.price) {
        return '0'
      }
      return (
        (this.calculated.price / 100).toLocaleString('ru-RU', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }) +
        ' ' +
        this.$tc('billing.moneyType.' + this.calculated.currency)
      )
    },
  },
})
